import BaseModule from "@/components/site-builder/BaseModule";
import type { AccordionModuleType } from "./types";
import { AccordionBlock } from "./AccordionBlock";

export interface AccordionModuleProps {
  module: AccordionModuleType;
}

export default function AccordionModule(props: AccordionModuleProps) {
  const { module } = props;
  const {
    body: { blocks, firstAccordionBlockOpen },
  } = module;

  return (
    <BaseModule module={module}>
      {blocks.map((block, index) => (
        <AccordionBlock
          key={index}
          block={block}
          defaultExpanded={firstAccordionBlockOpen && index === 0}
        />
      ))}
    </BaseModule>
  );
}
